export default "__VITE_ASSET__C5JJwuf8__"